//export const URLmy="http://localhost:3040";
export const URLmy="https://sputnik.operate.su";
export const URLmail="https://api.emailjs.com/api/v1.0/email/send";
